import type { ContextMenuItem } from "../ContextMenu/ContextMenu";

export const APPLE_SEARCH_HINT = "⌘K";
export const OTHER_SEARCH_HINT = "Ctrl+K";
const APPLE_USER_AGENT = /Mac|iPhone|iPad/;

export function isAppleUserAgent(): boolean {
  return typeof navigator !== "undefined" && APPLE_USER_AGENT.test(navigator.userAgent);
}

export function searchHint(apple: boolean): string {
  return apple ? APPLE_SEARCH_HINT : OTHER_SEARCH_HINT;
}

export interface ShellMenuActions {
  collapsed: boolean;
  searchHint: string;
  onSearch: () => void;
  onCollapsedChange: (collapsed: boolean) => void;
}

/** The suite's general right-click menu: browser navigation, search, link and sidebar. */
export function shellMenuItems({ collapsed, searchHint: hint, onSearch, onCollapsedChange }: ShellMenuActions): ContextMenuItem[] {
  return [
    { label: "Back", icon: "arrowLeft", onSelect: () => window.history.back() },
    { label: "Forward", icon: "arrowRight", onSelect: () => window.history.forward() },
    { label: "Reload", icon: "refresh", onSelect: () => window.location.reload() },
    "separator",
    { label: "Search the suite", icon: "search", hint, onSelect: onSearch },
    { label: "Copy link to this page", icon: "copy", onSelect: () => void navigator.clipboard?.writeText(window.location.href) },
    { label: collapsed ? "Expand the menu" : "Collapse the menu", icon: "panelLeft", onSelect: () => onCollapsedChange(!collapsed) },
  ];
}
